import React, { useState, useEffect, useContext } from "react";
import api from "../../api/axiosConfig";
import { ProjectContext } from "../../App";
import "../../styles/Settings/Countries.css";
import { FaChevronDown } from "react-icons/fa";
import EditIcon from "@mui/icons-material/Edit";

const Countries = () => {
  const { isNavBarOpen } = useContext(ProjectContext);
  const [countries, setCountries] = useState([]);
  const [form, setForm] = useState({ currency: "", country: "", symbol: "" });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countryDial, setCountryDial] = useState(false);
  const [selectedCountrytoDelete, setSelectedCountrytoDelete] = useState([]);

  const fetchData = async () => {
    try {
      const res = await api.get("/api/currency");
      setCountries(res.data);
    } catch (err) {
      setError(err.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/api/currency/${editingId}`, form);
      } else {
        await api.post("/api/currency", form);
      }
      setForm({ currency: "", country: "", symbol: "" });
      setEditingId(null);
      fetchData();
      setCountryDial(false);
    } catch (err) {
      alert("Error saving currency: " + (err.message || err));
    }
  };

  const handleEdit = (item) => {
    setForm({
      currency: item.currency,
      country: item.country,
      symbol: item.symbol,
    });
    setEditingId(item.id);
  };

  const handleBulkDelete = async (ids) => {
    if (!Array.isArray(ids) || ids.length === 0) return;

    if (window.confirm(`Delete ${ids.length} selected currencies?`)) {
      try {
        await api.post("/api/currency/delete", {
          selectedCountrytoDelete: ids,
        });
        setSelectedCountrytoDelete([]);
        fetchData();
      } catch (err) {
        alert("Error deleting currencies: " + (err.message || err));
      }
    }
  };

  const handleDeleteCountry = (e, groupId) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedCountrytoDelete((prev) => [...prev, groupId.id]); // Add customer ID to the list
    } else {
      setSelectedCountrytoDelete(
        (prev) => prev.filter((id) => id !== groupId.id) // Use the ID directly for filtering
      );
    }
  };

  return (
    <div className="country-container">
      <div
        className={isNavBarOpen ? "add-del-country" : "add-del-country-close"}
      >
        {selectedCountrytoDelete.length > 0 && (
          <button
            className="delete-country-button"
            onClick={() => handleBulkDelete(selectedCountrytoDelete)}
          >
            Delete
          </button>
        )}
        <button
          className="add-country-heading"
          onClick={() => setCountryDial(true)}
        >
          Add Country
        </button>
      </div>
      {countryDial && (
        <div className="add-group-d-dial">
          <div className="add-project-content">
            <div
              className="add-group-user-header"
              style={{ marginLeft: "0px" }}
            >
              <h3
                className="add-project-user-heading"
                style={{ marginLeft: "8px", fontWeight: "550px" }}
              >
                Add New Country
              </h3>
            </div>
            <form style={{ marginLeft: "0px" }} onSubmit={handleSubmit}>
              <div className="customer-form">
                <label className="customer-label">Currency Code:</label>
                <input
                  type="text"
                  name="currency"
                  placeholder="Currency Code (e.g., USD)"
                  value={form.currency}
                  onChange={handleChange}
                  required
                  className="customer-input"
                />
                <label className="customer-label">Country:</label>
                <input
                  type="text"
                  name="country"
                  placeholder="Country"
                  value={form.country}
                  onChange={handleChange}
                  required
                  className="customer-input"
                />
                <label className="customer-label">Symbol:</label>
                <input
                  type="text"
                  name="symbol"
                  placeholder="Symbol (e.g., $)"
                  value={form.symbol}
                  onChange={handleChange}
                  required
                  className="customer-input"
                />
              </div>
              <div className="group-btn-container">
                <button className="add-btn" type="submit">
                  {editingId ? "Update" : "Add"}
                </button>
                <button
                  className="cancel-btn"
                  onClick={() => setCountryDial(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : countries.length === 0 ? (
        <p>No currency data found.</p>
      ) : (
        <div
          className={
            isNavBarOpen
              ? "group-project-container"
              : "group-project-container-close"
          }
        >
          <table
            className={
              isNavBarOpen ? "group-content-table" : "group-content-table-close"
            }
          >
            <thead>
              <tr>
                <th style={{ width: "2px" }}>
                  <FaChevronDown />
                </th>
                <th style={{ width: "40px" }}>Currency</th>
                <th style={{ width: "100px" }}>Country</th>
                <th style={{ width: "40px" }}>Symbol</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {countries.map((item) => (
                <tr key={item.id}>
                  <td>
                    <input
                      style={{ cursor: "pointer" }}
                      type="checkbox"
                      name={item.id}
                      checked={selectedCountrytoDelete.includes(item.id)}
                      onChange={(e) => handleDeleteCountry(e, item)}
                    />
                  </td>
                  <td>
                    <div className="currency-con">
                      {item.currency}
                      <EditIcon
                        style={{
                          backgroundColor: "transparent",
                          color: "blue",
                          marginLeft: "15px",
                          marginTop: "2px",
                        }}
                        className="edit-icon-wrapper"
                        onClick={() => {
                          handleEdit(item);
                          setCountryDial(true);
                        }}
                      />
                    </div>
                  </td>
                  <td>{item.country}</td>
                  <td>{item.symbol}</td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default Countries;
